/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RptSalPlannedMeseAnnoImportoOutputDto interface.
 */
export function instanceOfRptSalPlannedMeseAnnoImportoOutputDto(value) {
    return true;
}
export function RptSalPlannedMeseAnnoImportoOutputDtoFromJSON(json) {
    return RptSalPlannedMeseAnnoImportoOutputDtoFromJSONTyped(json, false);
}
export function RptSalPlannedMeseAnnoImportoOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'salInviato': json['salInviato'] == null ? undefined : json['salInviato'],
        'salImporto': json['salImporto'] == null ? undefined : json['salImporto'],
        'dataInvioSal': json['dataInvioSal'] == null ? undefined : (new Date(json['dataInvioSal'])),
        'pkInvoiceMilestone': json['pkInvoiceMilestone'] == null ? undefined : json['pkInvoiceMilestone'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
    };
}
export function RptSalPlannedMeseAnnoImportoOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'salInviato': value['salInviato'],
        'salImporto': value['salImporto'],
        'dataInvioSal': value['dataInvioSal'] == null ? undefined : ((value['dataInvioSal']).toISOString().substring(0, 10)),
        'pkInvoiceMilestone': value['pkInvoiceMilestone'],
        'mese': value['mese'],
        'anno': value['anno'],
    };
}
